/**
 * Invoice brand lockup — theme-aware mark from public/social-logos.
 * @see src/components/Brand/GGJLogo.tsx
 */
import { BRAND_LOGOS } from './brandLogos';

export const BRAND_MARK_PURPLE = '#8B80F9';
export const BRAND_MARK_SRC = BRAND_LOGOS.markIconOnly.light;
export const BRAND_MARK_INVOICE_SRC = '/ggj-invoice-mark.png';
export const BRAND_MARK_ICON_SIZE = 48;
export const BRAND_NAME_FONT_SIZE = 17;

/** Stacked sidebar variant (optional — circle + GGJ in one image). */
export const BRAND_SIDEBAR_SRC = BRAND_LOGOS.stacked.light;
export const BRAND_SIDEBAR_INVOICE_SRC = '/ggj-invoice-sidebar.png';

export function brandMarkAssetUrl(): string {
  const site = (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, '');
  if (site) return `${site}${BRAND_MARK_SRC}`;
  if (typeof window !== 'undefined') return `${window.location.origin}${BRAND_MARK_SRC}`;
  return BRAND_MARK_SRC;
}

/** Pre-baked purple tile + silver mark (html2canvas / PDF safe). */
export function invoiceBrandMarkUrl(): string {
  const site = (import.meta.env.VITE_SITE_URL as string | undefined)?.replace(/\/$/, '');
  if (site) return `${site}${BRAND_MARK_INVOICE_SRC}`;
  if (typeof window !== 'undefined') return `${window.location.origin}${BRAND_MARK_INVOICE_SRC}`;
  return BRAND_MARK_INVOICE_SRC;
}

const bakedMarkCache = new Map<number, string>();

/** Bake brand mark for html2canvas PDF capture (icon PNG includes purple tile). */
export async function buildInvoiceBrandMarkDataUrl(
  iconSize = BRAND_MARK_ICON_SIZE,
): Promise<string> {
  const cached = bakedMarkCache.get(iconSize);
  if (cached) return cached;

  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const el = new Image();
    el.crossOrigin = 'anonymous';
    el.onload = () => resolve(el);
    el.onerror = () => reject(new Error('Failed to load GoGrabJob brand mark'));
    el.src = brandMarkAssetUrl();
  });

  const canvas = document.createElement('canvas');
  canvas.width = iconSize;
  canvas.height = iconSize;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Canvas not available');

  ctx.drawImage(img, 0, 0, iconSize, iconSize);

  const dataUrl = canvas.toDataURL('image/png');
  bakedMarkCache.set(iconSize, dataUrl);
  return dataUrl;
}
